import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { OnboardingStatus } from "@/_models/onboarding-status.interface";

@Injectable({ providedIn: "root" })
export class OnboardingStateService {
    private asapFormIdSubject = new BehaviorSubject<string | null>(null);
    private onboardingStatusSubject =
        new BehaviorSubject<OnboardingStatus | null>(null);

    readonly asapFormId$: Observable<string | null> =
        this.asapFormIdSubject.asObservable();
    readonly onboardingStatus$: Observable<OnboardingStatus | null> =
        this.onboardingStatusSubject.asObservable();

    setAsapFormId(id: string | null): void {
        this.asapFormIdSubject.next(id);
    }

    setOnboardingStatus(status: OnboardingStatus | null): void {
        this.onboardingStatusSubject.next(status);
    }

    getAsapFormIdSnapshot(): string | null {
        return this.asapFormIdSubject.getValue();
    }

    getOnboardingStatusSnapshot(): OnboardingStatus | null {
        return this.onboardingStatusSubject.getValue();
    }
}
